import { useState, useCallback } from "react"
import { usePage } from "@inertiajs/react"
import type { SharedProps } from "@/types"
import { useAccountChannel } from "@/hooks/use-account-channel"

export function useCreditBalance() {
  const { currentAccount } = usePage<SharedProps>().props
  const [liveBalance, setLiveBalance] = useState<number | null>(null)

  useAccountChannel(
    currentAccount?.id,
    useCallback((balance: number) => setLiveBalance(balance), []),
  )

  const balance = liveBalance ?? currentAccount?.credit_balance ?? 0
  const peak = currentAccount?.peak_credit_balance ?? 0
  const displayBalance = balance < 0 ? 0 : balance
  const percentage = peak > 0
    ? Math.max(0, Math.min(100, (balance / peak) * 100))
    : balance > 0 ? 100 : 0
  const isLow = peak > 0 && balance / peak < 0.15

  return { balance, displayBalance, peak, percentage, isLow }
}
